export default __webpack_public_path__ + "static/media/Captain's Vambraces of the Golden Sun.43ba82f3.jpg";